
import { Component, Model, Prop, PropSync, Vue } from "vue-property-decorator";
import { FormField } from "@/common/types";
import {
  MAX_DESCRIPTION_CHAR_NUM,
} from "@/common/config";
import { TicketForm } from "./LoggedInForm.utils";
import * as Locale from "@/plugins/i18n";

@Component({})
export default class LoggedInFormContent extends Vue {
  @Model("input") readonly form!: TicketForm;
  @PropSync("errors", { default: () => ({
    description: false,
    subject: false
  })}) readonly inputErrors!: {
    description: boolean;
    subject: boolean;
  };

  @Prop({ default: () => ([]) }) readonly fields!: FormField[];
  @Prop(Boolean) hasEmail!: boolean;

  readonly Locale = Locale;

  MAX_DESCRIPTION_CHAR_NUM = MAX_DESCRIPTION_CHAR_NUM;

  get descriptionLength() {
    return this.form.description?.length || 0;
  }

  get isDescriptionExceed() {
    return this.descriptionLength > MAX_DESCRIPTION_CHAR_NUM;
  }
}
